/**
 * LineChart tile (source=events, type=time_series). Highcharts line.
 * Backend returns { chart: 'line', x_axis: 'bucket', y_axis: 'v', rows: [...] }.
 */
import React, { useEffect, useRef } from 'react';
import Highcharts from 'highcharts';

export default function LineChart({ data }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !data?.rows) return;
    const rows = data.rows;
    const isStackedArea = data.chart === 'stacked_area';
    // Group by `series` (breakdown) if present, otherwise single series.
    const hasBreakdown = rows.some((r) => r.series != null);
    let series;
    if (hasBreakdown) {
      const grouped = new Map();
      rows.forEach((r) => {
        const k = String(r.series ?? '—');
        if (!grouped.has(k)) grouped.set(k, []);
        grouped.get(k).push([new Date(r.bucket).getTime(), Number(r.v)]);
      });
      series = Array.from(grouped.entries()).map(([name, data]) => ({ name, data, type: isStackedArea ? 'area' : 'line' }));
    } else {
      series = [{
        name: 'Volume',
        type: 'area',
        data: rows.map((r) => [new Date(r.bucket).getTime(), Number(r.v)]),
        fillOpacity: 0.15,
      }];
    }
    Highcharts.chart(ref.current, {
      chart: { type: 'line', height: 260, spacing: [10, 10, 10, 10] },
      title: { text: undefined },
      credits: { enabled: false },
      legend: { enabled: hasBreakdown, itemStyle: { fontSize: '11px' } },
      xAxis: {
        type: 'datetime',
        title: { text: data.x_label || 'Time', style: { fontSize: '10px', color: '#6b7280' } },
        labels: { style: { fontSize: '10px' } },
      },
      yAxis: {
        title: { text: data.y_label || 'Count', style: { fontSize: '10px', color: '#6b7280' } },
        labels: { style: { fontSize: '10px' } },
      },
      plotOptions: {
        line: { marker: { enabled: false }, lineWidth: 2 },
        area: { marker: { enabled: false }, stacking: isStackedArea ? 'normal' : undefined, fillOpacity: isStackedArea ? 0.55 : 0.15 },
      },
      tooltip: { shared: true, valueDecimals: 0 },
      series,
    });
  }, [data]);
  return <div ref={ref} style={{ width: '100%', minHeight: 260 }} />;
}
